import { Injectable } from '@angular/core';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root',
})
export class ConstantService {
  validatorPatterns: any = {
    alpha: /^(?![\s.-])[a-z\u0a80-\u0afe\u0900-\u097F .]+$/i,
    alphaNumeric: /[\u{61}-\u{7a}]+/gu,
    // alphaNumeric: /^[\u0030-\u0039\u0061-\u007A\u0041-\u005A\u0020\u007E-\uFFFF]+$/,
    Mobile: /^[6-9]\d{9}$/,
    Email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    address: /^\s*\S+(?:\s+\S+){1}/,
    ///^(\+\d{1,3}[- ]?)?\d{10}$/
    numeric: /^\d+$/,
    PANCardPattern: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/, //Ref- https://www.geeksforgeeks.org/how-to-validate-pan-card-number-using-regular-expression/?ref=lbp
    voterIDPattern: /^([a-zA-Z]){3}([0-9]){7}?$/g, // Ref - https://codingdiksha.com/javascript-tutorial-to-validate-indian-voter-id-number-format-using-regular-expression-in-browser/
    aadharCardPattern: /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/, // Ref- https://www.geeksforgeeks.org/how-to-check-aadhar-number-is-valid-or-not-using-regular-expression/
    indianPassportPattern: /^[A-PR-WYa-pr-wy][1-9]\\d\\s?\\d{4}[1-9]$/, //Ref -https://www.geeksforgeeks.org/how-to-validate-indian-passport-number-using-regular-expression/?ref=lbp,
    //drivingLicensePattern: /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/ //https://www.geeksforgeeks.org/how-to-validate-indian-driving-license-number-using-regular-expression/?ref=lbp
    drivingLicensePattern:
      /^(([A-Za-z]{2}[0-9]{2})|([A-Za-z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/, //https://www.geeksforgeeks.org/how-to-validate-indian-driving-license-number-using-regular-expression/?ref=lbp
    firstLetterString: /^[^0-9-\s](.*)?$/,
    noSpaceInStartString: /^[^-\s](.*)?$/,
    //decimalNumber:/^[1-9]\d*(\.\d+)?$/,
    decimalNumber: /^\d*\.\d{0,8}$/,
    vehicleNumber: /^[A-Za-z]{2}[0-9]{1,2}[A-Za-z]{1,2}[0-9]{3,4}$/,
    pincode: /^[0-9]{6}$/,
    //addressLine:/^\s*\S+(?:\s+\S+){1}/,
    noWhiteSpace: /[^\s]/,
    onlyDigits: /^[0-9]*$/,
  };

  designationData: any = {};

  // get configuration data of country based on code
  countryConfigData: any = {
    GBR: {
      mobile_length: 10,
      mobile_country_code: '+44',
      passport_regex: /^[a-zA-z0-9 ,.'-]+$/i,
    },
    USA: {
      mobile_length: 10,
      mobile_country_code: '+1',
      passport_regex: /^[a-zA-z0-9 ,.'-]+$/i,
    },
    IND: {
      mobile_length: 10, // number of digit // // Done
      mobile_country_code: '+91',
      passport_regex: /^[A-PR-WYa-pr-wy][1-9]\d\s?\d{4}[1-9]$/y, // regex // Done
    },
    AUS: {
      mobile_length: 9,
      mobile_country_code: '+61',
      passport_regex: /^[a-zA-Z0-9 ,.'-]+$/i,
    },
    UAE: {
      mobile_length: 9,
      mobile_country_code: '+971',
      passport_regex: /^[a-zA-Z0-9 ,.'-]+$/i,
    },
    NZL: {
      mobile_length: 9,
      mobile_country_code: '+64',
      passport_regex: /^[a-zA-Z0-9 ,.'-]+$/i,
    },
    KEN: {
      mobile_length: 9,
      mobile_country_code: '+254',
      passport_regex: /^[a-zA-Z0-9 ,.'-]+$/i,
    },
    BWA: {
      mobile_length: 8,
      mobile_country_code: '+267',
      passport_regex: /^[a-zA-Z0-9 ,.'-]+$/i,
    },
    MWI: {
      mobile_length: 9,
      mobile_country_code: '+265',
      passport_regex: /^[a-zA-Z0-9 ,.'-]+$/i,
    },
    RWA: {
      mobile_length: 9,
      mobile_country_code: '+250',
      passport_regex: /^[a-zA-Z0-9 ,.'-]+$/i,
    },
    ZAF: {
      mobile_length: 9,
      mobile_country_code: '+27',
      passport_regex: /^[a-zA-Z0-9 ,.'-]+$/i,
    },
    TZA: {
      mobile_length: 9,
      mobile_country_code: '+255',
      passport_regex: /^[a-zA-Z0-9 ,.'-]+$/i,
    },
    UGA: {
      mobile_length: 9,
      mobile_country_code: '+256',
      passport_regex: /^[a-zA-Z0-9 ,.'-]+$/i,
    },
    ZMB: {
      mobile_length: 9,
      mobile_country_code: '+260',
      passport_regex: /^[a-zA-Z0-9 ,.'-]+$/i,
    },
    ZWE: {
      mobile_length: 9,
      mobile_country_code: '+263',
      passport_regex: /^[a-zA-Z0-9 ,.'-]+$/i,
    },
  };

  optionList = {
    yesNo: [
      {
        title: 'Yes',
        slug: 1,
      },
      {
        title: 'No',
        slug: 0,
      },
    ],
    // Pratibhav (Sampark response) options — A/B/C. Sadbhavi grade now uses
    // `sadbhaviGrade` (A/B) for both its form and filter.
    grade: [
      {
        title: 'A',
        slug: 'A',
      },
      {
        title: 'B',
        slug: 'B',
      },
      {
        title: 'C',
        slug: 'C',
      },
    ],
    // Sadbhavi grade (form + filter): only A/B
    sadbhaviGrade: [
      {
        title: 'A',
        slug: 'A',
      },
      {
        title: 'B',
        slug: 'B',
      },
    ],
    messageReceipientGroupType: [
      {
        title: 'Designation',
        slug: 'designation',
      },
      {
        title: 'Department',
        slug: 'department',
      },
    ],
    SPCOUserType: [
      {
        title: 'સદ્‌ભાવી સંપર્ક કાર્યકર',
        slug: 'Sampark Sevak',
      },
      {
        title: 'કાર્યકર',
        slug: 'Karyakar',
      },
      {
        title: 'ઉપર માંથી કોઈ નહિ',
        slug: 'None of Above',
      },
    ],
    announceSevaStatus: [
      {
        value: 'All',
      },
      {
        value: 'Pending',
      },
      {
        value: 'Started',
      },
      {
        value: 'Completed',
      },
      {
        value: 'Absent',
      },
    ],
    entites: [
      { name: 'Purush', key: 'P' },
      { name: 'Mahila', key: 'M' },
      { name: 'Yuvak', key: 'Yu' },
      { name: 'Yuvati', key: 'Yi' },
      { name: 'None', key: 'N' },
    ],
    samparkStatus: [
      { title: 'Sampark Done' },
      { title: 'Not Allowed' },
      { title: 'Shifted/Closed Home' },
    ],
    samparkNumbers: [1, 2, 3, 4, 5, 6],
    attendSabha: [
      { title: 'Yes', slug: 'yes' },
      { title: 'No', slug: 'no' },
    ],
  };

  constructor(private permissionService: PermissionService) {}

  getMenuList() {
    let menuList: any[] = [];

    if (!!this.permissionService.checkMenuPermission('dashboard')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_HOME',
          link: '/',
          icon: 'fa fa-home',
        },
      ];
    }

    if (!!this.permissionService.checkMenuPermission('on-behalf-list')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_VIEW_KARYAKARS',
          link: '/on-behalf-list',
          icon: 'fa fa-user-circle-o',
        },
      ];
    }

    if (!!this.permissionService.checkMenuPermission('announcements')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_ANNOUNCEMENTS',
          link: '/announcement',
          icon: 'fa fa-bullhorn',
        },
      ];
    }

    if (!!this.permissionService.checkMenuPermission('form_fields')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_FORM_FIELDS',
          link: '/form-fields',
          icon: 'fa fa-list-alt',
        },
      ];
    }

    if (!!this.permissionService.checkMenuPermission('sampark_names')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_SAMPARK_NAMES',
          link: '/sampark-names',
          icon: 'fa fa-calendar',
        },
      ];
    }

    let message_read =
      this.permissionService.checkMenuPermission('message_read');
    let message_send =
      this.permissionService.checkMenuPermission('message_send');
    let message_review =
      this.permissionService.checkMenuPermission('message_review');

    if (!!this.permissionService.checkMenuPermission('messages')) {
      let messageMenuobj: any = {
        title: 'UI_MENU_MESSAGES',
        link: '/messages',
        icon: 'fa fa-comments',
        subMenus: [],
      };
      if (message_read) {
        messageMenuobj.subMenus.push({
          title: 'UI_MENU_INBOX',
          link: 'messages',
          icon: 'fa fa-arrow-circle-o-right',
        });
      }
      if (message_send) {
        messageMenuobj.subMenus.push({
          title: 'UI_MENU_SENT',
          link: 'messages/sent',
          icon: 'fa fa-arrow-circle-o-right',
        });
      }
      if (message_review) {
        messageMenuobj.subMenus.push({
          title: 'UI_MENU_REVIEW',
          link: 'messages/review',
          icon: 'fa fa-arrow-circle-o-right',
        });
      }
      menuList = [...menuList, messageMenuobj];
    }

    let general_support =
      this.permissionService.checkMenuPermission('general_support');
    let karykar_update =
      this.permissionService.checkMenuPermission('karykar_update');
    let sadbhavi_support =
      this.permissionService.checkMenuPermission('sadbhavi_support');
    if (karykar_update || sadbhavi_support || general_support) {
      let supportMenuobj: any = {
        title: 'UI_MENU_SUPPORT',
        link: '',
        icon: 'fa fa-ticket',
        subMenus: [],
      };
      if (karykar_update) {
        supportMenuobj.subMenus.push({
          title: 'UI_MENU_KARYKAR_UPDATE',
          link: 'support/karykar-update',
          icon: 'fa fa-arrow-circle-o-right',
        });
      }
      if (general_support) {
        supportMenuobj.subMenus.push({
          title: 'UI_MENU_GENERAL_SUPPORT',
          link: 'support/sampark-sevak-support',
          icon: 'fa fa-arrow-circle-o-right',
        });
      }
      if (sadbhavi_support) {
        supportMenuobj.subMenus.push({
          title: 'UI_MENU_SADBVHI_SUPPORT',
          link: 'support/sadbhavi-support',
          icon: 'fa fa-arrow-circle-o-right',
        });
      }
      menuList = [...menuList, supportMenuobj];
    }

    if (!!this.permissionService.checkMenuPermission('audit_log')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_AUDIT_LOG',
          link: '/audit-log',
          icon: 'fa fa-history',
        },
      ];
    }

    let r_ssmw = this.permissionService.checkMenuPermission('r_ssmw');
    let r_ssmw_weekly =
      this.permissionService.checkMenuPermission('r_ssmw_weekly');
    let r_san = this.permissionService.checkMenuPermission('r_san');
    let r_smsv = this.permissionService.checkMenuPermission('r_smsv');
    let r_sav = this.permissionService.checkMenuPermission('r_sav');

    if (!!r_ssmw || !!r_ssmw_weekly || !!r_san || !!r_smsv || !!r_sav) {
      let reportMenuobj: any = {
        title: 'UI_MENU_REPORTS',
        link: '',
        icon: 'fa fa-bar-chart',
        subMenus: [],
      };

      if (!!r_ssmw) {
        reportMenuobj.subMenus.push({
          title: 'UI_MENU_SSMW',
          link: 'reports/ssmw',
          icon: 'fa fa-arrow-circle-o-right',
        });
      }

      if (!!r_ssmw_weekly) {
        reportMenuobj.subMenus.push({
          title: 'UI_MENU_SSMW_WEEKLY',
          link: 'reports/r_ssmw_weekly',
          icon: 'fa fa-arrow-circle-o-right',
        });
      }

      if (!!r_san) {
        reportMenuobj.subMenus.push({
          title: 'UI_MENU_SAN_SAX',
          link: 'reports/r_san',
          icon: 'fa fa-arrow-circle-o-right',
        });
      }

      if (!!r_smsv) {
        reportMenuobj.subMenus.push({
          title: 'UI_MENU_ANNUAL_SUMMARY',
          link: 'reports/r_smsv',
          icon: 'fa fa-arrow-circle-o-right',
        });
      }

      if (!!r_sav) {
        reportMenuobj.subMenus.push({
          title: 'UI_MENU_SAV',
          link: 'reports/r_sav',
          icon: 'fa fa-arrow-circle-o-right',
        });
      }

      menuList = [...menuList, reportMenuobj];
    }

    if (!!this.permissionService.checkMenuPermission('sampark_sevak')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_SADBHAVI_SAMPARK_KARYAKARS',
          link: '/sampark-sevaks',
          icon: 'fa fa-user-circle-o',
        },
      ];
    }

    if (!!this.permissionService.checkMenuPermission('sadbhavi')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_SADBHAVI',
          link: '/sadbhavi',
          icon: 'fa fa-user-circle-o',
        },
      ];
    }

    if (!!this.permissionService.checkMenuPermission('spco_users')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_SPCO_USERS',
          link: '/spco_users',
          icon: 'fa fa-user-plus',
        },
      ];
    }
    if (!!this.permissionService.checkMenuPermission('vrunds')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_VRUND',
          link: '/vrunds',
          icon: 'fa fa-users',
        },
      ];
    }

    if (!!this.permissionService.checkMenuPermission('vrund_snx')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_VRUND_SNX',
          link: '/vrund-snx',
          icon: 'fa fa-user-plus',
        },
      ];
    }

    if (!!this.permissionService.checkMenuPermission('sadbhavi_sampark_list')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_SADBHAVI_SAMPARK',
          link: '/sadbhavi_sampark',
          icon: 'fa fa-address-book',
        },
      ];
    }
    if (!!this.permissionService.checkMenuPermission('video_app')) {
      menuList = [
        ...menuList,
        {
          title: 'UI_MENU_VIDEO_APP',
          link: '/video_app',
          icon: 'fa fa-video-camera',
        },
      ];
    }

    return menuList;
  }

  //
  getCountryConfigDetail(countrCode: any = 'IND') {
    if (
      !!countrCode &&
      !!this.countryConfigData &&
      this.countryConfigData[countrCode]
    ) {
      return this.countryConfigData[countrCode];
    } else {
      return null;
    }
  }

  eventList = [
    'Sadbhavi Updated',
    'Sampark Sevak Updated',
    'Sadbhavi Deleted',
    'Sampark Sevak Created',
    'User Updated',
    'Sadbhavi Created',
  ];
  targetEntity = ['Announcements', 'User', 'Sadbhavi'];
}
